// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file common.proto (package cryptotrader, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file common.proto.
 */
export const file_common: GenFile = /*@__PURE__*/
  fileDesc("Cgxjb21tb24ucHJvdG8SDGNyeXB0b3RyYWRlciIHCgVFbXB0eUJHWkVjb2RlYmVyZy5vcmcvQ3J5cHRvVHJhZGVyL2FwcC9wcm90by9nZW4vY3J5cHRvdHJhZGVycGI7Y3J5cHRvdHJhZGVycGJiBnByb3RvMw");

/**
 * @generated from message cryptotrader.Empty
 */
export type Empty = Message<"cryptotrader.Empty"> & {
};

/**
 * Describes the message cryptotrader.Empty.
 * Use `create(EmptySchema)` to create a new message.
 */
export const EmptySchema: GenMessage<Empty> = /*@__PURE__*/
  messageDesc(file_common, 0);

